import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Flame } from "lucide-react";

export default function About() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/content/about").then(r => setC(r.data)); }, []);
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="flex items-center gap-2 mb-3"><Flame className="text-[#FF4500]"/><span className="text-xs font-bold tracking-widest text-slate-500">ABOUT STYLEFIRE</span></div>
      <h1 className="font-display text-4xl md:text-5xl font-bold mb-6">{c?.title || "About Stylefire"}</h1>
      <div className="prose prose-slate max-w-none whitespace-pre-line text-slate-700 leading-relaxed">{c?.body}</div>
      <div className="mt-10 bg-slate-50 rounded-2xl p-6 text-sm text-slate-700">
        <div className="font-semibold mb-1">Founders</div>
        <div>Biswajit & Pragyna Paramita Dash</div>
      </div>
    </main>
  );
}
